import React from 'react';
import { Sparkle } from 'phosphor-react';

interface AiChatCardProps {
  onOpenChat: () => void;
}

/** Card da IA do mock (2026-06-11): chamada + botão que abre o chat. */
export default function AiChatCard({ onOpenChat }: AiChatCardProps) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl p-5 shadow-soft dark:shadow-none dark:border dark:border-gray-700 mt-2">
      <p className="text-sm font-bold text-gray-800 dark:text-gray-100">
        Converse com a IA sobre sua rotina
      </p>
      <p className="text-xs text-nude-400 dark:text-gray-400 mt-1">
        Tire dúvidas, entenda sua pele e receba sugestões personalizadas.
      </p>
      <button
        onClick={onOpenChat}
        className="mt-4 w-full flex items-center justify-center gap-2 py-3 rounded-xl text-sm font-semibold text-white bg-blush-500 hover:bg-blush-600 active:scale-[0.97] transition-colors shadow-glow-blush"
      >
        <Sparkle className="w-4 h-4" />
        Falar com a IA
      </button>
    </div>
  );
}
